<div class="cb-slider-container">
  <div class="cb-slider-header">
    <label>{{label}}</label>
    <p>{{currentStepLabel}}</p>
  </div>
  <div class="cb-slider">
    <p-slider [(ngModel)]="value" (onChange)="change()" [min]="min" [max]="max" [step]="step"></p-slider>
  </div>
</div>
